import { createContext, useContext, useState, useEffect } from 'react'
import { getMe } from '../services/api'

const AuthContext = createContext(null)

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null) // { id, email, name, role }
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    const token = sessionStorage.getItem('adminToken')
    if (!token) {
      setLoading(false)
      return
    }
    getMe()
      .then((res) => setUser(res.data))
      .catch(() => setUser(null))
      .finally(() => setLoading(false))
  }, [])

  const isAdmin = user?.role === 'ADMIN'
  const isStaff = user?.role === 'STAFF'
  const isViewer = user?.role === 'VIEWER'
  const isInvoiceCreator = user?.role === 'INVOICE_CREATOR'

  return (
    <AuthContext.Provider value={{ user, loading, isAdmin, isStaff, isViewer, isInvoiceCreator, setUser }}>
      {children}
    </AuthContext.Provider>
  )
}

export function useAuth() {
  const ctx = useContext(AuthContext)
  if (!ctx) throw new Error('useAuth must be inside AuthProvider')
  return ctx
}
